<template>
    <Dropdown
        v-if="typesOptions && typesOptions.length > 0"
        class="me-1 mb-1 types-filter"
        :color="isActive ? 'success' : 'secondary'"
        :title="isActive ? `Filter by types (${value.length})` : 'Filter by types'"
        small
    >
        <li v-for="type in typesOptions" :key="type.id">
            <button
                @click="setSelectedTypes(type.id)"
                class="dropdown-item text-xs"
                :class="value.includes(type.id) ? 'bg-primary text-white' : 'bg-white'"
            >
                {{ type.label }}
            </button>
        </li>
    </Dropdown>
</template>

<script>
    import Types from '@/mixins/Types'
    import { Dropdown } from '@tech_hexeko/design-system'

    export default {
        components: {
            Dropdown,
        },
        mixins: [Types],
        props: {
            value: {
                type: Array,
                required: true,
            },
        },
        emits: ['input'],
        computed: {
            isActive() {
                return this.value && this.value.length > 0
            },
        },
        methods: {
            setSelectedTypes(id) {
                if (this.value.includes(id)) {
                    this.$emit(
                        'input',
                        this.value.filter((typeId) => typeId !== id)
                    )
                } else {
                    this.$emit('input', [...this.value, id])
                }
            },
        },
    }
</script>

<style scoped>
    .types-filter {
        margin-top: 0.4rem;
    }
</style>
